import $ from 'jquery';
import { onScroll, getScrollTop } from '../utils/window';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');

	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			if (headerToggler.isOpen) {
				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
			}
		});
	}

	const headerHeight = $header.height();
	let lastScrollTop = 0;

	onScroll(function(){

		var st = getScrollTop();
		if (st > lastScrollTop){
			// downscroll code

			if(getScrollTop() > headerHeight && !$header.hasClass('is-hidden')) {
				$header.addClass('is-hidden');
			}
		} else {
		   // upscroll code

		   if($header.hasClass('is-hidden')) {
				$header.removeClass('is-hidden');
			}
		}
		lastScrollTop = st;

	});

}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js